const lclExportChargesData = {
    colNames : {
        twoSpan: 'Per Unit',
        twoSpan1: 'Per W/M',
        twoSpan2: 'Minimum',
        perShipment: 'Per Shipment'
    },
    initialLength: 14,
    preList: [{
            id: 1,
            chargeDescription: 'Pick-up Charges',
            currency: 'INR',
            disabled: ['perWM', 'minimum']
        },
        {
            id: 2,
            chargeDescription: 'Origin Customs Clearance',
            currency: 'INR',
            disabled: ['perWM', 'minimum']
        },
        {
            id: 3,
            chargeDescription: 'Origin Charges',
            currency: 'INR'
        },
        {
            id: 4,
            chargeDescription: 'Origin Inland Haulage',
            currency: 'INR'
        },
        {
            id: 5,
            chargeDescription: 'Ocean Freight',
            currency: 'USD',
            disabled: ['perShipment']
        },
        {
            id: 6,
            chargeDescription: 'Hazardous Surcharge',
            currency: 'USD',
            disabled: ['perWM', 'minimum']
        },
        {
            id: 7,
            chargeDescription: 'Non-Stackable Surcharge',
            currency: 'USD'
        },
        {
            id: 8,
            chargeDescription: 'Destination Inland Haulage',
            currency: ''
        },
        {
            id: 9,
            chargeDescription: 'Destination Charges',
            currency: ''
        },
        {
            id: 10,
            chargeDescription: 'Destination CFS Charges',
            currency: ''
        },
        {
            id: 11,
            chargeDescription: 'Destination Customs Clearance',
            currency: '',
            disabled: ['perWM', 'minimum']
        },
        {
            id: 12,
            chargeDescription: 'Delivery Charges',
            currency: '',
            disabled: ['perWM', 'minimum']
        },{
            id: 13,
            chargeDescription: 'Terminal Handling Fees',
            currency: '',
              disabled: ['perWM', 'minimum']
        },{
            id: 14,
            chargeDescription: 'BL Fees',
            currency: '',
              disabled: ['perWM', 'minimum']
        }
    ]
}
export default lclExportChargesData